module.exports = __webpack_public_path__ + "static/media/darkroom.21360a8b.png";